import React from 'react';
import { NavigationSmall } from '@hm-group/fabric-components';
import cn from 'classnames';
import "./BreadcrumbLink.css";
var styles = { "breadcrumbLink-hm": "f296d8", "breadcrumbLink-monki": "b60484", "breadcrumbLink-northstar": "b925e5" };
const BreadcrumbLink = ({ variant = 'hm', Tag, customProps, onItemClick, isCurrentPage, href, eventLabel, additionalClass, children, }) => {
    const isNS = variant === 'northstar';
    const isCustomLinkElement = !!Tag && !!customProps;
    const baseLinkProps = isCustomLinkElement
        ? Object.assign({ Tag }, customProps) : { href: href || '' };
    const sharedProps = Object.assign(Object.assign({ onClick: () => onItemClick && onItemClick(eventLabel) }, (isCurrentPage && { 'aria-current': 'page' })), (!isNS && Object.assign({}, baseLinkProps)));
    return isNS ? (React.createElement("a", Object.assign({}, sharedProps, { href: href || '', className: styles['breadcrumbLink-northstar'] }), children)) : (React.createElement(NavigationSmall, Object.assign({}, sharedProps, { className: cn(styles[`breadcrumbLink-${variant}`], additionalClass && additionalClass) }), children));
};
export default BreadcrumbLink;
//# sourceMappingURL=BreadcrumbLink.js.map